export default [
  {
    question: "¿Con qué frecuencia usas las mascarillas?",
    answer1: "Siempre",
    answer2: "Casi siempre",
    answer3: "Frecuentemente",
    answer4: "A veces",
    answer5: "Casi nunca",
    answer6: "Nunca",
    img: "/images/survey/mascarilla.svg",
    advice: "Debes usar la mascarilla con más frecuencia.",
    inverted: true,
  },
  {
    question: "¿Con qué frecuencia te lavas las manos?",
    answer1: "Siempre",
    answer2: "Casi siempre",
    answer3: "Frecuentemente",
    answer4: "A veces",
    answer5: "Casi nunca",
    answer6: "Nunca",
    img: "/images/survey/lavado-manos.svg",
    advice: "Debes lavarte las manos con más frecuencia.",
    inverted: true,
  },
  {
    question:
      "¿Cuántas horas a la semana pasas fuera de casa en lugares abiertos?",
    answer1: "Más de 50",
    answer2: "40 a 50",
    answer3: "30 a 40",
    answer4: "20 a 30",
    answer5: "10 a 20",
    answer6: "0 a 10",
    img: "/images/survey/espacios-abiertos.svg",
    advice: "",
    inverted: false,
  },
  {
    question:
      "¿Cuántas horas a la semana pasas fuera de casa en lugares cerrados?",
    answer1: "Más de 50",
    answer2: "40 a 50",
    answer3: "30 a 40",
    answer4: "20 a 30",
    answer5: "10 a 20",
    answer6: "0 a 10",
    img: "/images/survey/espacios-cerrados.svg",
    advice: "",
    inverted: false,
  },
  {
    question: "¿Con qué frecuencia te tocas la cara?",
    answer1: "Siempre",
    answer2: "Casi siempre",
    answer3: "Frecuentemente",
    answer4: "A veces",
    answer5: "Casi nunca",
    answer6: "Nunca",
    img: "/images/survey/tocar-cara.svg",
    advice: "Intenta ser consciente y no tocarte la cara.",
    inverted: false,
  },
  {
    question: "Sin contarte a ti, ¿con cuántas personas convives en tu casa?",
    answer1: "5 o más",
    answer2: "4",
    answer3: "3",
    answer4: "2",
    answer5: "1",
    answer6: "0",
    img: "/images/survey/habitantes-casa.svg",
    advice: "",
    inverted: false,
  },
  {
    question: "¿Mantienes distanciamiento social con la gente que te rodea?",
    answer1: "Siempre",
    answer2: "Casi siempre",
    answer3: "Frecuentemente",
    answer4: "A veces",
    answer5: "Casi nunca",
    answer6: "Nunca",
    img: "/images/survey/distanciamiento.svg",
    advice: "Intenta mantener distanciamiento social.",
    inverted: true,
  },
  {
    question: "¿Manejas dinero en efectivo?",
    answer1: "Siempre",
    answer2: "Casi siempre",
    answer3: "Frecuentemente",
    answer4: "A veces",
    answer5: "Casi nunca",
    answer6: "Nunca",
    img: "/images/survey/dinero.svg",
    advice: "",
    inverted: false,
  },
  {
    question: "¿Cuántos minutos a la semana utilizas el ascensor comunitario?",
    answer1: "Nunca",
    answer2: "0 a 2",
    answer3: "2 a 5",
    answer4: "5 a 10",
    answer5: "10 a 20",
    answer6: "Más de 20",
    img: "/images/survey/ascensor.svg",
    advice: "Intenta subir por las escaleras, y así hacer ejercicio.",
    inverted: true,
  },
  {
    question: "¿Cuántas horas a la semana utilizas el transporte público?",
    answer1: "Más de 25",
    answer2: "20 a 25",
    answer3: "15 a 20",
    answer4: "10 a 15",
    answer5: "5 a 10",
    answer6: "0 a 5",
    img: "/images/survey/transporte-publico.svg",
    advice: "",
    inverted: false,
  },
];
